<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="taskName">
      <el-tab-pane label="二维码模板" name="list"></el-tab-pane>
    </el-tabs>
    <CodeTemplate v-if="taskName == 'list'"></CodeTemplate>
  </div>
</template>
<script>
  import CodeTemplate from './codetemplate/index';
export default {
  components: {
    CodeTemplate,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      taskName: 'list'
    };
  },
  methods: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/codetemplate/index.vue